// extracted by mini-css-extract-plugin
export default {"formContainer":"panel_formContainer__D9+r0"};